import React from 'react'
import HomeIndex from '../Components/Home/HomeIndex'

const Home = () => {
  return (
    <HomeIndex />
  )
}

export default Home